import React from 'react';

const MARK_PATH =
  'M33.8954 6H6.10263C6.10263 20.7841 17.6125 33.0129 32.3695 33.9075L33.8954 34V6Z';

interface RudderstackMarkProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Draws the mark as an outline instead of a fill, so it sits with the line icons (e.g. the
   * sidebar menu). The stroke is 2.5 units of the 40-unit box: 1px at 16px, like those icons.
   */
  isOutlined?: boolean;
}

/**
 * The RudderStack quarter-sail mark —
 * the product logo shape, used in the chat's empty state (muted), the turn
 * signature (brand blue), and outlined as the sidebar's Lookout icon.
 * `currentColor` so the parent picks the tint.
 */
export const RudderstackMark: React.FC<RudderstackMarkProps> = ({
  isOutlined = false,
  ...props
}) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {isOutlined ? (
      <path d={MARK_PATH} stroke="currentColor" strokeWidth={2.5} strokeLinejoin="round" />
    ) : (
      <path d={MARK_PATH} fill="currentColor" />
    )}
  </svg>
);
